import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {SubscribeThemeComponent} from './subscribe-theme.component';

@NgModule({
  declarations: [SubscribeThemeComponent],
  imports: [CommonModule],
  exports: [SubscribeThemeComponent],
})
export class SubscribeThemeModule {}
